module.exports = __webpack_public_path__ + "static/media/squarespace.5ff6b7cc.svg";